import { render, staticRenderFns } from "./fileTree.vue?vue&type=template&id=1165c2c7&scoped=true"
import script from "./fileTree.vue?vue&type=script&lang=js"
export * from "./fileTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165c2c7",
  null
  
)

export default component.exports